import { render, staticRenderFns } from "./PCRPathogenDashboard.vue?vue&type=template&id=67d73c6e&scoped=true"
import script from "./PCRPathogenDashboard.vue?vue&type=script&lang=js"
export * from "./PCRPathogenDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d73c6e",
  null
  
)

export default component.exports